import { render, staticRenderFns } from "./JStreamPlayer.vue?vue&type=template&id=650383e9&"
import script from "./JStreamPlayer.vue?vue&type=script&lang=js&"
export * from "./JStreamPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports